import React, { useEffect, useRef } from "react";
import Select, { components } from "react-select";
import { Modal } from "react-bootstrap";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaPlus,
  FaUndo,
  FaSave,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { getAllPatient } from "../../../store/slices/patientSlice";
import AddUpdateModal from "../../components/Patient/AddUpdateModal";
import { getCountrySlice } from "../../../store/slices/countrySlice";
import { getDistricSlice } from "../../../store/slices/districtSlice";
import { getCitySlice } from "../../../store/slices/citySlice";
import {
  refundPharmaSalesSlice,
  resetRefundPharmaSalesMessage,
} from "../../../store/slices/pharmaSalesSlice";
import {
  createPatientData,
  resetMessage,
} from "../../../store/slices/patientSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import showTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import AsyncSelect from "react-select/async";
import { getAllStockSlice } from "../../../store/slices/stockInventorySlice";

const AddUpdatePharmaSales = ({
  showModal,
  setShowModal,
  handleAddUpdate,
  isMode,
  handleSelectChange,
  physician,
  state,
  medicines,
  salesFormData,
  setSalesFormData,
  handlePlaceChange,
  handlePrescriberChange,
  modalAction,
  accountType,
  bank,
  setPaymentStatus,
}) => {
  const [showResult, setShowResult] = useState(true);
  const [medicineRows, setMedicineRows] = useState([
    {
      medicine: null,
      quantity: "",
      rate: "",
      total: "",
      stockId: "",
      batchNumber: "",
      expiryDate: "",
      isRefundEditing: false,
      refundReason: "",
      refundQty: "",
    },
  ]);

  const [discountType, setDiscountType] = useState("amount"); // or "percent"
  const [discountValue, setDiscountValue] = useState("");
  const [netTotal, setNetTotal] = useState("0.00");
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [patientFormData, setPatientFormData] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    passport: false,
    aadhar: false,
  });
  const resetForm = () => {
    setPatientFormData({
      clinicId: clinicInfo[0]?.clinicId,
      userType: 1,
      name: "",
      email: "",
      phone: "",
      alternate_Phone: "",
      city: "",
      cityName: "",
      country: "",
      countryName: "",
      state: "",
      stateName: "",
      address: "",
      pin: "",
      gender: "",
      age: "",
      dob: "",
      HC_number: "",
      aadhar_number: "",
      passport: "",
      blood_group: "",
      membership_group: "",
      patient_image: "",
      abhaNumber: "",
      abhaAddress: "",
    });
  };
  const searchInputRef = useRef(null);
  const searchResultRef = useRef(null);
  const { users } = useSelector((state) => state.users);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { districts } = useSelector((state) => state.district);
  const { cities } = useSelector((state) => state.city);
  const { Country } = useSelector((state) => state.country);
  const { refundPharmaSalesSuccessMessage, refundPharmaSalesErrorMessage } =
    useSelector((state) => state.pharmaSales);

  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCountrySlice({ status: ["Active"], token }));
  }, [dispatch, token]);

  useEffect(() => {
    if (showModal && modalAction === "create") {
      setMedicineRows([
        {
          medicine: null,
          quantity: "",
          rate: "",
          total: "",
          stockId: "",
          batchNumber: "",
          expiryDate: "",
          isRefundEditing: false,
          refundReason: "",
          refundQty: "",
        },
      ]);
      setDiscountType("amount");
      setDiscountValue("");
      setNetTotal("0.00");
      setSalesFormData({
        patientId: "",
        patientName: "",
        prescribedBy: "",
        placeOfSupply: "",
        placeOfSupplyName: "",
        accountType: "",
        accountTypeName: "",
        bank: "",
        bankName: "",
        paymentStatus: "UNPAID",
        isAlreadyPaid: false,
      });
    }
  }, [showModal, modalAction]);

  const handleMedicineChange = (selectedOption, index) => {
    const selectedMedicine = medicines.find(
      (med) => med._id === selectedOption.value,
    );
    const updatedRows = [...medicineRows];

    updatedRows[index].medicine = selectedOption;
    updatedRows[index].stockId = selectedOption?.value || "";
    updatedRows[index].rate = selectedMedicine?.mrp || "";
    updatedRows[index].batchNumber = selectedMedicine?.batchNumber || "";
    updatedRows[index].expiryDate = selectedMedicine?.expiryDate || "";

    const qty = parseFloat(updatedRows[index]?.quantity) || 0;
    const rate = parseFloat(updatedRows[index]?.rate) || 0;
    updatedRows[index].total = (qty * rate).toFixed(2);

    setMedicineRows(updatedRows);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedRows = [...medicineRows];
    updatedRows[index][field] = value;

    if (field === "quantity" || field === "rate") {
      const qty = parseFloat(updatedRows[index]?.quantity) || 0;
      const rate = parseFloat(updatedRows[index]?.rate) || 0;
      updatedRows[index].total = (qty * rate).toFixed(2);
    }

    if (field === "refundQty") {
      const discountValue = parseFloat(salesFormData?.discount) || 0;
      const subTotal = parseFloat(salesFormData?.subTotal) || 0;
      const discountPercent =
        subTotal > 0 ? (discountValue / subTotal) * 100 : 0;

      const refundQty = parseFloat(value) || 0;
      const rate = parseFloat(updatedRows[index]?.rate) || 0;
      const rawAmount = refundQty * rate;
      const discountAmount = (rawAmount * discountPercent) / 100;
      const finalRefundAmount = rawAmount - discountAmount;

      updatedRows[index].refundAmount = finalRefundAmount.toFixed(2);
    }

    setMedicineRows(updatedRows);
  };

  const addMedicineRow = () => {
    setMedicineRows([
      ...medicineRows,
      {
        medicine: null,
        quantity: "",
        rate: "",
        total: "",
        stockId: "",
        batchNumber: "",
        expiryDate: "",
        isRefundEditing: false,
        refundReason: "",
        refundQty: "",
      },
    ]);
  };

  const removeMedicineRow = (index) => {
    const updatedRows = medicineRows?.filter((_, i) => i !== index);
    setMedicineRows(updatedRows);
  };

  const calculateSubtotal = () => {
    return medicineRows?.reduce((acc, row) => {
      const total = parseFloat(row?.total) || 0;
      return acc + total;
    }, 0);
  };

  useEffect(() => {
    const subtotal = calculateSubtotal();
    let discount = 0;

    if (discountType === "percent") {
      const percent = parseFloat(discountValue) || 0;
      discount = (subtotal * percent) / 100;
    } else {
      discount = parseFloat(discountValue) || 0;
    }

    const net = subtotal - discount;
    setNetTotal(net?.toFixed(2));
  }, [medicineRows, discountValue, discountType]);
  useEffect(() => {
    if (
      modalAction === "edit" ||
      (modalAction === "refund" &&
        salesFormData?.items?.length > 0 &&
        medicines?.length)
    ) {
      const transformedRows = salesFormData?.items?.map((item) => {
        const med = medicines?.find((m) => m?._id === item.stockId?._id);

        return {
          medicine: med
            ? { value: med?._id, label: med?.name }
            : {
                value: item?.stockId?._id || "",
                label: item?.stockId?.name || "Unknown",
              },
          stockId: item?.stockId || "",
          quantity: item?.quantity || "",
          rate: item?.rate || "",
          total: item?.total || "",
          batchNumber: item?.batchNumber || "",
          expiryDate: item?.expiryDate || "",
          refundQty: item?.returnedQuantity || "",
          refundAmount: item?.returnedPrice || "",
          refundStatus: item?.returnStatus || "Not Returned",
        };
      });

      setMedicineRows(transformedRows);
      setDiscountType(salesFormData?.discountType || "amount");
      setDiscountValue(salesFormData?.discount || "");
      setNetTotal(salesFormData?.afterDiscount || "");
    }
  }, [modalAction, salesFormData, medicines]);

  const filteredBanks = salesFormData?.accountType
    ? bank?.filter(
        (b) =>
          b?.accountType && b?.accountType._id === salesFormData?.accountType,
      )
    : [];

  const Genderoptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "TransGender", label: "TransGender" },
  ];
  /* New Patient add start */

  const BloodGroupOptions = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
  ];

  const MembershipOptions = [
    { value: "General", label: "General" },
    { value: "Gold", label: "Gold" },
    { value: "Silver", label: "Silver" },
  ];
  const handleChange = (e) => {
    if (e.dob && e.age) {
      setPatientFormData((prev) => ({
        ...prev,
        dob: e.dob,
        age: e.age,
      }));
    } else {
      const { name, value } = e.target;
      setPatientFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handlePatientSelectChange = async (selectedOption, name) => {
    if (name === "country") {
      setPatientFormData((prevData) => ({
        ...prevData,
        country: selectedOption.value,
        countryName: selectedOption.label,
        state: "",
        stateName: "",
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      // await dispatch(getStateSlice({ countryId: selectedOption.value, token }));
    } else if (name === "state") {
      setPatientFormData((prevData) => ({
        ...prevData,
        state: selectedOption.value,
        stateName: selectedOption.label,
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      await dispatch(getDistricSlice({ stateId: selectedOption.value, token }));
    } else if (name === "district") {
      setPatientFormData((prevData) => ({
        ...prevData,
        district: selectedOption.value,
        districtName: selectedOption.label,
        city: "",
        cityName: "",
      }));
      await dispatch(
        getCitySlice({
          countryId: patientFormData.country,
          stateId: patientFormData.state,
          districtId: selectedOption.value,
          token,
        }),
      );
    } else if (name === "city") {
      setPatientFormData((prevData) => ({
        ...prevData,
        city: selectedOption.value,
        cityName: selectedOption.label,
      }));
    } else {
      setPatientFormData((prev) => ({
        ...prev,
        [name]: selectedOption.value,
      }));
    }
  };

  const handleFileChange = (file) => {
    if (file) {
      setPatientFormData((prevData) => ({
        ...prevData,
        patient_image: file,
      }));
    }
  };

  const handleAddPatient = async (e) => {
    e.preventDefault();
    const requiredFields = ["gender", "country", "state", "district", "city"];
    const errors = {};

    requiredFields.forEach((field) => {
      if (!patientFormData[field]) {
        errors[field] = `Please select ${field}`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    const { name, email, phNumber, aadhar, passport } = inputError;
    if (name || email || phNumber || aadhar || passport) {
      return;
    }
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("clinicId", clinicId);
      formDataToSend.append("clinicUserId", userInfo?._id);
      formDataToSend.append("name", patientFormData?.name || "");
      formDataToSend.append("email", patientFormData?.email || "");
      formDataToSend.append("phone", patientFormData?.phone || "");
      formDataToSend.append(
        "alternate_Phone",
        patientFormData?.alternate_Phone || "",
      );
      formDataToSend.append("userType", 1);
      formDataToSend.append("gender", patientFormData?.gender || "");
      formDataToSend.append("dob", patientFormData?.dob || "");
      formDataToSend.append("HC_number", patientFormData?.HC_number || "");
      formDataToSend.append(
        "aadhar_number",
        patientFormData?.aadhar_number || "",
      );
      formDataToSend.append("passport", patientFormData?.passport || "");
      formDataToSend.append("blood_group", patientFormData?.blood_group || "");
      formDataToSend.append("status", patientFormData?.status || "");
      formDataToSend.append(
        "membership_group",
        patientFormData?.membership_group || "",
      );
      formDataToSend.append("country", patientFormData?.country || "");
      formDataToSend.append("state", patientFormData?.state || "");
      formDataToSend.append("city", patientFormData?.city || "");
      formDataToSend.append("district", patientFormData?.district || "");
      formDataToSend.append("pin", patientFormData?.pin || "");
      formDataToSend.append("address", patientFormData?.address || "");
      formDataToSend.append("day", patientFormData?.age?.day || "");
      formDataToSend.append("month", patientFormData?.age?.month || "");
      formDataToSend.append("year", patientFormData?.age?.year || "");
      formDataToSend.append("abhaNumber", patientFormData?.abhaNumber || "");
      formDataToSend.append("abhaAddress", patientFormData?.abhaAddress || "");
      if (patientFormData.patient_image) {
        formDataToSend.append("patient_image", patientFormData?.patient_image);
      }
      const response = await dispatch(
        createPatientData({ formDataToSend, token }),
      );
      const newPatient = response?.payload?.result?.list;
      if (newPatient?.patientId) {
        setShowPatientModal(false);
        setShowModal(true);
        setPatientFormData({});
        setSalesFormData((prev) => ({
          ...prev,
          patientId: newPatient?.patientId,
          patientName: newPatient?.name,
        }));

        setTimeout(() => {
          dispatch(resetMessage());
        }, 500);
      }
    } catch (error) {
      console.error("Error details:", error);
    }
  };
  const refundMedicines = async (row, index) => {
    const discountValue = salesFormData?.discount || 0;
    const subTotal = salesFormData?.subTotal || 0;
    const discountPercent = (discountValue / subTotal) * 100;

    const updatedRows = [...medicineRows];
    if (!row.isRefundEditing) {
      updatedRows[index].isRefundEditing = true;
    } else {
      // Perform save logic for refund
      const refundData = {
        saleId: salesFormData?.salesId,
        clinicId,
        returnedBy: userInfo?._id,
        items: [
          {
            stockId: row.stockId._id,
            returnQty: Number(row?.refundQty) || 0,
          },
        ],
      };
      const res = await dispatch(
        refundPharmaSalesSlice({ ...refundData, token }),
      );
      //       if (res?.payload?.success) {
      //   showToastifySuccess("Refund successful");
      // } else {
      //   showToastifyError(res?.payload?.message || "Refund failed");
      // }
      updatedRows[index].isRefundEditing = false;
    }
    setMedicineRows(updatedRows);
  };

  const isAnyRowRefundEditing = medicineRows?.some(
    (row) => row.isRefundEditing,
  );

  useEffect(() => {
    if (refundPharmaSalesSuccessMessage) {
      showToastifySuccess(refundPharmaSalesSuccessMessage);
      dispatch(resetRefundPharmaSalesMessage());
    }

    if (refundPharmaSalesErrorMessage) {
      showToastifyError(refundPharmaSalesErrorMessage);
      dispatch(resetRefundPharmaSalesMessage());
    }
  }, [
    refundPharmaSalesSuccessMessage,
    refundPharmaSalesErrorMessage,
    dispatch,
  ]);

  const loadPatientOptions = async (inputValue) => {
    try {
      const res = await dispatch(
        getAllPatient({
          patientAssociationId: clinicId,
          searchQuery: inputValue,
          token,
        }),
      );

      const patientList = res?.payload?.result.list || [];

      const options = patientList.map((p) => ({
        value: p?._id,
        label: p?.userId?.name,
      }));

      return [
        ...options,
        {
          value: "add_new",
          label: "Add New Patient",
          isAddNew: true,
        },
      ];
    } catch (error) {
      return [];
    }
  };

  const CustomOption = (props) => {
    const { data } = props;

    if (data.isAddNew) {
      return (
        <div
          {...props.innerProps}
          className="px-3 py-2 text-primary d-flex align-items-center"
          style={{ cursor: "pointer" }}
        >
          <FaPlus className="me-2" />
          Add New Patient
        </div>
      );
    }

    return <components.Option {...props} />;
  };

  const loadMedicineOptions = async (inputValue) => {
    const response = await dispatch(
      getAllStockSlice({
        clinicId,
        token,
        search: inputValue,
        // limit: 10,
        // currentPage: 1,
      }),
    );

    const data = response?.payload?.result?.list || [];

    return data
    .filter((item) => item.quantity > 0)
    .map((item) => ({
      value: item._id,
      label: `${item.name} (${item.quantity})`,
    }));
  };

  return (
    <>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {modalAction === "edit" || modalAction === "refund"
              ? "UPDATE SALES"
              : "ADD SALES"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAddUpdate({
                medicineRows,
                discountType,
                discountValue,
              });
            }}
          >
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Patient Name</label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    loadOptions={loadPatientOptions}
                    placeholder="Search Patient"
                    components={{ Option: CustomOption }}
                    value={
                      salesFormData?.patientName
                        ? {
                            value: salesFormData?.patientId,
                            label: salesFormData?.patientName,
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption?.value === "add_new") {
                        setShowModal(false);
                        setShowPatientModal(true);
                        resetForm();
                      } else {
                        handleSelectChange(selectedOption, "patient");
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Prescribed By</label>
                  <Select
                    name="prescribedBy"
                    value={
                      salesFormData?.prescribedBy
                        ? {
                            value: salesFormData?.prescribedBy,
                            label: salesFormData?.prescribedBy,
                          }
                        : null
                    }
                    placeholder="Select Physician"
                    onChange={(selectedOption) =>
                      handlePrescriberChange(selectedOption, "prescriber")
                    }
                    options={physician?.map((item) => ({
                      value: item?.userId?.name,
                      label: item?.userId?.name,
                    }))}
                    isDisabled={
                      modalAction === "edit" || modalAction === "refund"
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Place Of Supply</label>
                  <Select
                    name="placeOfSupply"
                    value={
                      salesFormData?.placeOfSupply
                        ? {
                            value: salesFormData?.placeOfSupply,
                            label: salesFormData?.placeOfSupplyName,
                          }
                        : null
                    }
                    placeholder="Select Place"
                    onChange={(selectedOption) =>
                      handlePlaceChange(selectedOption, "placeOfSupply")
                    }
                    options={state?.map((item) => ({
                      value: item?._id,
                      label: item?.gstCode
                        ? `${item?.gstCode} - ${item?.name}`
                        : `${item?.name}`,
                    }))}
                    isDisabled={
                      modalAction === "edit" || modalAction === "refund"
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label d-block">
                    Payment Status
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentStatus"
                      id="Paid"
                      value="PAID"
                      checked={salesFormData?.paymentStatus === "PAID"}
                      onChange={(e) => setPaymentStatus(e?.target?.value)}
                      disabled={salesFormData?.isAlreadyPaid === true}
                    />
                    <label className="form-check-label" htmlFor="Paid">
                      Paid
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentStatus"
                      id="Unpaid"
                      value="UNPAID"
                      checked={salesFormData?.paymentStatus === "UNPAID"}
                      onChange={(e) => setPaymentStatus(e?.target?.value)}
                      disabled={salesFormData?.isAlreadyPaid === true}
                    />
                    <label className="form-check-label" htmlFor="Unpaid">
                      Unpaid
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="col-form-label">Account Type:</label>
                    <Select
                      value={
                        salesFormData?.accountType
                          ? {
                              value: salesFormData?.accountType,
                              label: salesFormData?.accountTypeName,
                            }
                          : null
                      }
                      placeholder="Select Account Type"
                      options={accountType?.map((account) => ({
                        value: account?._id,
                        label: account?.name,
                      }))}
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "accountType")
                      }
                      isDisabled={
                        salesFormData?.paymentStatus !== "PAID" ||
                        salesFormData?.isAlreadyPaid === true
                      }
                    />
                  </div>
                </div>

                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="col-form-label">Bank:</label>
                    <Select
                      required
                      value={
                        salesFormData?.bank
                          ? {
                              value: salesFormData?.bank,
                              label: salesFormData?.bankName,
                            }
                          : null
                      }
                      placeholder="Select Bank"
                      options={filteredBanks?.map((b) => ({
                        value: b?._id,
                        label: b?.name,
                      }))}
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "bank")
                      }
                      isDisabled={
                        !salesFormData?.accountType ||
                        salesFormData?.isAlreadyPaid === true
                      }
                    />
                  </div>
                </div>
                {/* )} */}
              </div>

              <div className="mt-4">
                <h6>Medicines</h6>
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th
                        style={{
                          width: modalAction === "refund" ? "20%" : "30%",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          width: modalAction === "refund" ? "10%" : "15%",
                        }}
                      >
                        Batch No.
                      </th>
                      <th
                        style={{
                          width: modalAction === "refund" ? "10%" : "15%",
                        }}
                      >
                        Expiry Date
                      </th>
                      <th
                        style={{
                          width: modalAction === "refund" ? "10%" : "15%",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          width: modalAction === "refund" ? "15%" : "15%",
                        }}
                      >
                        Rate (MRP)
                      </th>
                      <th
                        style={{
                          width: modalAction === "refund" ? "10%" : "15%",
                        }}
                      >
                        Total
                      </th>
                      {modalAction === "refund" && isAnyRowRefundEditing && (
                        <>
                          <th style={{ width: "15%" }}>Refund Qty</th>
                          <th style={{ width: "15%" }}>Refund Amount</th>
                        </>
                      )}
                      {modalAction === "refund" && (
                        <th style={{ width: "10%" }}>Refund Status</th>
                      )}
                      {modalAction !== "edit" && (
                        <th style={{ width: "10%" }}>Actions</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {medicineRows?.map((row, index) => (
                      <tr key={index}>
                        <td>
                          <AsyncSelect
                            cacheOptions
                            loadOptions={loadMedicineOptions}
                            defaultOptions
                            value={row?.medicine}
                            onChange={(option) =>
                              handleMedicineChange(option, index)
                            }
                            placeholder="Select Medicine"
                            isDisabled={
                              modalAction === "edit" || modalAction === "refund"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Batch No."
                            value={row?.batchNumber}
                            onChange={(e) =>
                              handleFieldChange(
                                index,
                                "batchNumber",
                                e?.target?.value,
                              )
                            }
                            readOnly={
                              modalAction === "edit" || modalAction === "refund"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="Expiry Date"
                            value={row?.expiryDate?.split("T")[0]}
                            onChange={(e) =>
                              handleFieldChange(
                                index,
                                "expiryDate",
                                e?.target?.value,
                              )
                            }
                            readOnly={
                              modalAction === "edit" || modalAction === "refund"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Qty"
                            value={row?.quantity}
                            onChange={(e) =>
                              handleFieldChange(
                                index,
                                "quantity",
                                e?.target?.value,
                              )
                            }
                            readOnly={
                              modalAction === "edit" || modalAction === "refund"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Rate"
                            value={row?.rate}
                            readOnly // optional to prevent manual changes
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row?.total}
                            readOnly
                          />
                        </td>
                        {modalAction === "refund" && isAnyRowRefundEditing && (
                          <>
                            <td>
                              {row?.isRefundEditing ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter refund Qty"
                                  value={row?.refundQty}
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "refundQty",
                                      e?.target?.value,
                                    )
                                  }
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {row?.isRefundEditing ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter refund Amount"
                                  value={row?.refundAmount}
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "refundAmount",
                                      e?.target?.value,
                                    )
                                  }
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                          </>
                        )}
                        {modalAction === "refund" && (
                          <td>
                            <span
                              style={{
                                fontWeight: [
                                  "Returned",
                                  "Not Returned",
                                ].includes(row?.refundStatus)
                                  ? "bold"
                                  : "normal",
                                color:
                                  row?.refundStatus === "Returned"
                                    ? "#f11e1eff"
                                    : row?.refundStatus === "Not Returned"
                                      ? "#ffb800"
                                      : "inherit",
                              }}
                            >
                              {row?.refundStatus}
                            </span>
                          </td>
                        )}
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            {medicineRows?.length > 1 &&
                              modalAction !== "edit" &&
                              modalAction !== "refund" && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeMedicineRow(index)}
                                >
                                  <FaMinusCircle />
                                </button>
                              )}
                            {index === medicineRows?.length - 1 &&
                              modalAction !== "edit" &&
                              modalAction !== "refund" && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success"
                                  onClick={addMedicineRow}
                                >
                                  <FaPlusCircle />
                                </button>
                              )}
                            {medicineRows?.length >= 1 &&
                              modalAction === "refund" && (
                                <button
                                  type="button"
                                  className={`btn btn-sm ${
                                    row?.isRefundEditing
                                      ? "btn-success"
                                      : "btn-warning"
                                  }`}
                                  onClick={() => refundMedicines(row, index)}
                                  disabled={row?.refundStatus === "Returned"}
                                >
                                  {row?.isRefundEditing &&
                                  row?.refundStatus !== "Returned" ? (
                                    <FaSave />
                                  ) : (
                                    <FaUndo />
                                  )}
                                </button>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="row justify-content-end mt-3">
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="fw-bold">Subtotal:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={calculateSubtotal().toFixed(2)}
                        readOnly
                      />
                    </div>
                    <div className="mb-2">
                      <label className="fw-bold">Discount:</label>
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Discount"
                          value={discountValue}
                          onChange={(e) => setDiscountValue(e.target.value)}
                          readOnly={
                            (modalAction === "edit" &&
                              salesFormData?.paymentStatus === "PAID") ||
                            modalAction === "refund"
                              ? true
                              : false
                          }
                        />
                        {/* {(modalAction !== "edit" && salesFormData?.paymentStatus !== "PAID") &&
                          modalAction !== "refund" && ( */}
                        <select
                          className="form-select"
                          value={discountType}
                          onChange={(e) => setDiscountType(e.target.value)}
                          disabled={
                            (modalAction === "edit" &&
                              salesFormData?.paymentStatus === "PAID") ||
                            modalAction === "refund"
                          }
                        >
                          <option value="amount">₹</option>
                          <option value="percent">%</option>
                        </select>
                        {/* )} */}
                      </div>
                    </div>
                    <div>
                      <label className="fw-bold">Net Total:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={netTotal}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={salesFormData?.isAlreadyPaid === true}
              >
                {modalAction === "edit" || modalAction === "refund"
                  ? "Update"
                  : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <AddUpdateModal
        modalVisible={showPatientModal}
        setModalVisible={setShowPatientModal}
        formData={patientFormData}
        setFormData={setPatientFormData}
        inputError={inputError}
        setInputError={setInputError}
        dispatch={dispatch}
        resetForm={resetForm}
        cities={cities}
        Country={Country}
        state={state}
        districts={districts}
        handleFileChange={handleFileChange}
        handleSelectChange={handlePatientSelectChange}
        handleChange={handleChange}
        handleAddPatient={handleAddPatient}
        bloodGroupOptions={BloodGroupOptions}
        membershipOptions={MembershipOptions}
        genderOptions={Genderoptions}
        fieldErrors={fieldErrors}
        setFieldErrors={setFieldErrors}
      />
    </>
  );
};

export default AddUpdatePharmaSales;
